var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 18.75H14.9902C14.5802 18.75 14.2402 18.41 14.2402 18C14.2402 17.59 14.5802 17.25 14.9902 17.25H16.5002C19.1202 17.25 21.2502 15.12 21.2502 12.5C21.2502 9.88 19.1202 7.75 16.5002 7.75H15.0002C14.5902 7.75 14.2502 7.41 14.2502 7C14.2502 6.59 14.5802 6.25 15.0002 6.25H16.5002C19.9502 6.25 22.7502 9.05 22.7502 12.5C22.7502 15.95 19.9502 18.75 16.5002 18.75Z",
    fill: "#4DA8B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.75H7.5C4.05 18.75 1.25 15.95 1.25 12.5C1.25 9.05 4.05 6.25 7.5 6.25H9C9.41 6.25 9.75 6.59 9.75 7C9.75 7.41 9.41 7.75 9 7.75H7.5C4.88 7.75 2.75 9.88 2.75 12.5C2.75 15.12 4.88 17.25 7.5 17.25H9C9.41 17.25 9.75 17.59 9.75 18C9.75 18.41 9.41 18.75 9 18.75Z",
    fill: "#4DA8B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.25H8C7.59 13.25 7.25 12.91 7.25 12.5C7.25 12.09 7.59 11.75 8 11.75H16C16.41 11.75 16.75 12.09 16.75 12.5C16.75 12.91 16.41 13.25 16 13.25Z",
    fill: "#4DA8B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.dd2115dc9431d5e742b8757b6056814a.svg";
export { ForwardRef as ReactComponent };